import { FC } from 'react';
import SelectCompany from 'src/components/SelectCompany';
import Button from 'src/components/design-system/Button';
import useBoolean from 'src/hooks/useBoolean';
import useCompany from 'src/hooks/useCompany';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import InvoiceUploadFilesModal from './InvoiceUploadFilesModal';

interface DropDownProps {}

const InvoiceScanManagerHeader: FC<DropDownProps> = () => {
  const {
    count,
    showPrev,
    setShowPrev,
    refreshPage,
    refreshCompany,
    setRefreshCompany,
    setOcrCompanies,
    isHidePreview,
    tab,
  } = useInvoiceScanManager();
  const { company: selectedCompany } = useCompany();
  const { value: isUploadOpen, setTrue: openUpload, setFalse: closeUpload } = useBoolean();

  return (
    <>
      {isUploadOpen && (
        <InvoiceUploadFilesModal
          open={isUploadOpen}
          closeModal={closeUpload}
          refreshParent={refreshPage}
          setRefreshCompany={setRefreshCompany}
        />
      )}

      <nav className="flex items-center pt-1 flex-wrap">
        <div className="w-[389px]">
          <SelectCompany
            isInvoice={true}
            isScanManager={true}
            setOcrCompanies={setOcrCompanies}
            refreshCompany={refreshCompany}
            selectSuperAdmin={tab ? true : false}
          />
        </div>
        <div className="flex-grow flex justify-center">
          {selectedCompany?.companyId && (
            <Button color="primary" onClick={openUpload}>
              Upload Document
            </Button>
          )}
        </div>
        <div className="flex-grow flex justify-end">
          {selectedCompany?.companyId && !isHidePreview && (
            <Button
              onClick={() => setShowPrev((prev) => !prev)}
              endIcon={
                <div className="bg-dark rounded-full h-5 w-5 flex items-center justify-center text-[0.6rem] text-white">
                  {count}
                </div>
              }
              color="light"
            >
              {!showPrev ? 'Show Scans' : 'Hide Scans'}
            </Button>
          )}
        </div>
      </nav>
    </>
  );
};

export default InvoiceScanManagerHeader;
